import { Flex, Divider, Box, Text } from "@chakra-ui/react";
import { permissionFor } from "@syla/shared/types/helpers/permissions";
import React, { useContext } from "react";
import {
  UserTaxOutcomes,
  UserTransactions,
  UserRemainingParcels,
} from "../../../constants/SupportCsvDocument";
import { SylaSampleUrls } from "../../../constants/SylaSampleUrls";
import { canUnlockPlanFeature } from "../../../helper/canUnlockPlanFeature";
import { TaxReportsContext } from "../../../pages/TaxReports";
import { useGlobalVariablesStore } from "../../../store/globalVariablesStore";
import { ContentHeadingContainer, SectionCard } from "../../atoms/Containers";
import { SectionHeading } from "../../atoms/Headings";
import { DocumentContainer } from "./DocumentContainer";
import { SupportDocumentRow } from "./SupportDocumentRow";

export const SupportDocumentSummary = (): JSX.Element => {
  const selectedFinancialYear = useGlobalVariablesStore(
    (state) => state.selectedFinancialYear,
  );
  const { isLoading, subscriptions, txCount, account } =
    useContext(TaxReportsContext);

  const canPurchase = canUnlockPlanFeature(account);

  return (
    <SectionCard>
      <ContentHeadingContainer>
        <Flex direction="row" alignItems="center">
          <SectionHeading>Assurance Documents</SectionHeading>
        </Flex>
      </ContentHeadingContainer>
      <Text color="gray.600" fontSize="sm" mx="20px">
        Supporting documents and exports.
      </Text>
      <Divider mt="1rem" borderColor="gray.300" />

      <Box overflowX={"auto"}>
        <DocumentContainer>
          <SupportDocumentRow
            isLoading={isLoading}
            canPurchase={canPurchase}
            canDownload={
              permissionFor({
                feature: UserTaxOutcomes.feature,
                subscriptions,
                transactionCount: txCount,
                account,
              }).hasPermission
            }
            csvDocument={UserTaxOutcomes}
            sampleUrl={SylaSampleUrls.TaxOutcomes}
          />
          <SupportDocumentRow
            isLoading={isLoading}
            canPurchase={canPurchase}
            canDownload={
              permissionFor({
                feature: UserTransactions.feature,
                subscriptions,
                transactionCount: txCount,
                account,
              }).hasPermission
            }
            csvDocument={UserTransactions}
            sampleUrl={SylaSampleUrls.Transactions}
          />
          {selectedFinancialYear && (
            <SupportDocumentRow
              isLoading={isLoading}
              canPurchase={canPurchase}
              canDownload={
                permissionFor({
                  feature: UserRemainingParcels.feature,
                  subscriptions,
                  transactionCount: txCount,
                  account,
                }).hasPermission
              }
              csvDocument={UserRemainingParcels}
              sampleUrl={SylaSampleUrls.CostBaseRemainingAssets}
            />
          )}
        </DocumentContainer>
      </Box>
    </SectionCard>
  );
};
